import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import DebugOverlay from "./components/DebugOverlay";
import { api } from "./api";

import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import AdminSettings from "./pages/AdminSettings";
import TodoList from "./pages/TodoList";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import InviteSetup from "./pages/InviteSetup";
import Jour from "./pages/Jour";
import VacationMy from "./pages/VacationMy";
import VacationAdmin from "./pages/VacationAdmin";
import VacationOverview from "./pages/VacationOverview";
import CompletedAdmin from "./pages/CompletedAdmin";
import BugReport from "./pages/BugReport";
import BugList from "./pages/BugList";
import HomePage from "./pages/HomePage";

// Reminder imports
import VehicleList from './pages/reminder/VehicleList';
import EmployeeList from './pages/reminder/EmployeeList';
import WarningsView from './pages/reminder/WarningsView';

// Wrapper för att kunna hämta dev-settings efter login
function AppRoutes() {
  const { user } = useAuth();
  const [showDebug, setShowDebug] = useState(false);

  useEffect(() => {
    async function loadDevFlag() {
      if (user?.isDev) {
        try {
          const { data } = await api.get("/admin/settings");
          const ds = data.dev || [];
          const debugSetting = ds.find((s) => s.key === "showDebugOverlay");
          setShowDebug(!!debugSetting?.value);
        } catch (e) {
          console.warn("Kunde inte ladda dev-settings", e);
          setShowDebug(false);
        }
      } else {
        setShowDebug(false);
      }
    }
    loadDevFlag();
  }, [user]);

  return (
    <>
      <Navbar />
      <div className="container pb-5">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/reset" element={<ResetPassword />} />
          <Route path="/invite" element={<InviteSetup />} />

          <Route
            path="/vacation"
            element={
              <ProtectedRoute>
                <VacationMy />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vacation-admin"
            element={
              <ProtectedRoute role="admin">
                <VacationAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vacation-overview"
            element={
              <ProtectedRoute>
                <VacationOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute allowIncomplete>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute role="admin">
                <AdminSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/todo"
            element={
              <ProtectedRoute>
                <TodoList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jour"
            element={
              <ProtectedRoute>
                <Jour />
              </ProtectedRoute>
            }
          />
          <Route
            path="/completed-admin"
            element={
              <ProtectedRoute role="admin">
                <CompletedAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bugreport"
            element={
              <ProtectedRoute>
                <BugReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bug-list"
            element={
              <ProtectedRoute>
                <BugList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vehicles"
            element={
              <ProtectedRoute role="admin">
                <VehicleList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/warnings"
            element={
              <ProtectedRoute role="admin">
                <WarningsView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ssg"
            element={
              <ProtectedRoute role="admin">
                <EmployeeList />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>

      {/* DebugOverlay visas bara om dev + inställningen är på */}
      {user?.isDev && <DebugOverlay show={showDebug} />}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
